import { Box, Link, Text } from '@chakra-ui/react';
import InfoBanner from '../../common/InfoBanner';
import { CustomInfoIcon } from '../../../theme/icons/CustomInfoIcon';

const SmsStatusDelayNotice = () => (
  <Box mb="16px">
    <InfoBanner
      color="#1868DB"
      bg="#E5F6FB"
      icon={<CustomInfoIcon boxSize="20px" color="#009BD6" />}
      borderRadius="5px"
      hasLeftBorder={false}
      mt={0}
    >
      <Text textStyle="bodyFamilyRegular" fontSize="13px">
        SMS and MMS statuses can take a few hours to update. We monitor for
        failed messages. If a status hasn&apos;t changed after 24 hours, please{' '}
        <Link href="mailto:support@passentry.com" textDecoration="underline">
          contact support
        </Link>
        .
      </Text>
    </InfoBanner>
  </Box>
);

export default SmsStatusDelayNotice;
